import { format } from 'owa-strings';
var weatherSpriteStyles = require('owa-sprite/dist/styles/weather_sprite.css');
// 0 is the fallback 'unknown' image.
export default function getWeatherImage(skyCodeId) {
    if (skyCodeId === void 0) { skyCodeId = 0; }
    skyCodeId = skyCodeId < 4 || skyCodeId > 83 ? 0 : skyCodeId; // Set the valid ranges.
    return weatherSpriteStyles[format('weather-icon-SkyCode_32pct_{0}', skyCodeId)];
}
//# sourceMappingURL=getWeatherImage.js.map